<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent, computed, watch } from "@vue/composition-api"
import { useWebview } from "@/composable/useWebview"
import { DefaultRoute } from "@/router/lib/default-routes"
import { canJoinRoleProtectedRoute } from "@/auth/authGuard"
import { useStore } from "@/composable/useStore"
import { OrganizationType } from "@/types/organization"
import { navigate } from "@/router"
import { UserRoleEnum } from "@/types/user"

export default defineComponent({
  name: "AppRootRoute",
  setup() {
    const { organizationModule } = useStore()
    const { appLauncherDetected } = useWebview()

    const organizationType = computed(() => {
      return organizationModule.organizationDetail.organizationType
    })

    const isOrganizationType = (type: OrganizationType) => {
      return organizationModule.organizationDetail.organizationType === type
    }

    const handleRouteRedirect = () => {
      if (isOrganizationType(OrganizationType.CustomerHosted)) {
        navigate({ name: DefaultRoute.CUSTOMER_HOSTED })
      } else if (isOrganizationType(OrganizationType.SaaS)) {
        const superRole = canJoinRoleProtectedRoute(UserRoleEnum.SysAdmin)

        if (superRole) {
          navigate({ name: DefaultRoute.CUSTOMER_HOSTED })
        } else {
          if (appLauncherDetected.value) {
            navigate({ name: DefaultRoute.SAAS_APP_LAUNCHER })
          } else {
            navigate({ name: DefaultRoute.SAAS_BROWSER })
          }
        }
      }
    }

    const onCreate = () => {
      handleRouteRedirect()
    }

    onCreate()

    watch(organizationType, () => {
      handleRouteRedirect()
    })
  }
})
</script>
